export default __webpack_public_path__ + "static/first-9f9196072d220cb2c4fd30d38741eb68.png";